import React from 'react';

function LoadingState() {
  return <div style={{ height: 500 }} className="skeleton-v2" />;
}

export default LoadingState;
